
import { useStateMachine } from "little-state-machine";
import { resetAction } from "../actions";
import { APPLY_NEW_TRADE_WASTE_PERMIT } from "../../Constants";
import { motion } from "framer-motion";
import { useTradeWasteContext } from "../tradeWasteContext";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const Receipt = () => {
  const [tradeWasteContext, dispatch] = useTradeWasteContext();
  const navigate = useNavigate()
  const [email, setEmail] = useState("")
  const { actions, state } = useStateMachine({ resetAction });
  useEffect(() => {
    if (!email) {
      // New
      if (state?.data?.operator_email && state?.data?.trade_waste_application_type == APPLY_NEW_TRADE_WASTE_PERMIT) {
        setEmail(state?.data?.operator_email);
      }
      // Others
      else {
        setEmail(state?.data?.email);
      }
    }
  }, [email, state])
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const startAgain = () => {
    actions.resetAction();
    dispatch({ type: "deleteUploads" })
    navigate("/");
  };

  return (
    <motion.div
      className="mb-8"
      data-testid="receipt"
      key="receipt"
      initial="initial"
      animate="in"
      exit="out"
      variants={{
        initial: {
          opacity: 0,
        },
        in: {
          opacity: 1,
        },
        out: {
          opacity: 0,
        },
      }}
    >
      <div>
        <h2>Thank you for submitting your application.</h2>
        <p>
          Your application will be assessed and our team will be in touch if we required any further information.
        </p>
        {email ? (
          <p>
            An email confirmation has been sent to{" "}
            <strong>{email}</strong>
          </p>
        ) : (<></>)}

        <p>
          If you have any queries about your application, please contact us on{" "}
          <a href={`mailto:${tradeWasteContext?.emailAddress ?? ""}`}>
            {tradeWasteContext?.emailAddress ?? ""}
          </a>
        </p>
      </div>
      <button type="reset" className="btn-primary btn-mobile" onClick={startAgain}>start a new form</button>
    </motion.div>
  );
};

export default Receipt;
